<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">แบบฟอร์มคำร้องขอใช้บริการพื้นที่</div>
        <div class="d-flex align-center">
          <Iconify
            icon="bxs:message-square-detail"
            color="var(--theme-color-seven)"
            class="mr-3"
          ></Iconify>
          แบบฟอร์มคำร้องขอใช้บริการพื้นที่ที่ส่งยื่น
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div
            class="flex-center gap-8"
            style="max-width: 250px"
            v-if="!this.isOIC"
          >
            <div class="min-width-max">สถานะ</div>
            <SelectBox
              placeholder="สถานะ"
              hide-details
              clearable
              :items="statusMaster"
              item-text="label"
              item-value="value"
              @onChange="
                searchData.status = $event;
                getAllForms();
              "
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-inner-icon="search"
              @onChange="searchData.keyword = $event"
              @onEnter="getAllForms()"
            ></TextField>
          </div>
        </div>
        <div class="d-flex justify-end" v-if="!this.isOIC">
          <Button @onClick="createForm"> กรอกแบบฟอร์ม</Button>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
          v-for="(item, i) in tableHeader"
          :key="i"
          :style="{ width: item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <div v-for="(item, i) in requestList" :key="i">
          <RowCard :key="i" :multiLine="true" :theme="changeColor(item.status)">
            <div :style="{ width: tableHeader[0].width }" class="d-flex mt-n1">
              <v-btn
                v-if="item.status === 'Draft'"
                small
                icon
                @click="onEdit(item.id)"
              >
                <Iconify icon="material-symbols:edit" size="15px"></Iconify>
              </v-btn>
              <v-btn
                v-if="['Submitted', 'Approved', 'In Review'].includes(item.status)"
                small
                icon
                @click="goToRequestPreview(item.id)"
              >
                <Iconify icon="carbon:view-filled" size="15px"></Iconify>
              </v-btn>
              <v-btn
                v-if="item.status === 'Draft'"
                small
                icon
                @click="onDelete(item.id)"
              >
                <Iconify
                  style="color: #b1b1b1"
                  icon="basil:trash-alt-solid"
                  size="15px"
                ></Iconify>
              </v-btn>
            </div>

            <div :style="{ width: tableHeader[1].width }">{{ item.count }}</div>
            <div :style="{ width: tableHeader[2].width }">{{ item.year }}</div>
            <div :style="{ width: tableHeader[3].width }">
              {{ item.no }}
            </div>
            <div :style="{ width: tableHeader[4].width }">
              <div>
                {{ item?.area_form_2?.company_name_th }}
              </div>
              <div class="py-2">
                วันที่อนุมัติ : {{ dateFormatting(item?.approved_at) ?? "-" }}
              </div>
              <div>วันที่ออก : {{ dateFormatting(item?.exit_at) ?? "-" }}</div>
            </div>
            <div :style="{ width: tableHeader[5].width }">
              <div v-if="item?.created_by" class="one-line font-type-normal">
                <tooltip-text :text="item?.created_by" />
              </div>
            </div>
            <div
              :style="{
                width: tableHeader[6].width,
                color: statusColorSeparator(item.status),
              }"
            >
              {{ item.status }}
            </div>
          </RowCard>
        </div>

        <v-pagination
          class="mt-6"
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          @input="getAllForms"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from "@/components/input/TextField";
import SelectBox from "@/components/input/SelectBox";
import Button from "@/components/input/Button";
import RowCard from "@/components/RowCard";
import { mapState } from "vuex";

export default {
  name: "RequestList",
  components: {
    TextField,
    SelectBox,
    Button,
    RowCard,
  },
  data() {
    return {
      tableHeader: [
        {
          name: "",
          width: "6%",
        },
        {
          name: "ลำดับ",
          width: "6%",
        },
        {
          name: "ปี งปม.",
          width: "8%",
        },
        {
          name: "เลขที่",
          width: "8%",
        },
        {
          name: "ชื่อบริษัท (ภาษาไทย)",
          width: "46%",
        },
        {
          name: "ผู้นำเข้าข้อมูล",
          width: "13%",
        },
        {
          name: "สถานะ",
          width: "13%",
        },
      ],
      searchData: {
        status: null,
        keyword: null,
      },
      statusMaster: [
        { label: "แบบร่าง", value: "Draft" },
        { label: "รอยื่นพิจารณา", value: "Submitted" },
        { label: "รอพิจารณา", value: "In Review" },
        { label: "ผ่านเกณฑ์พิจารณา", value: "Approved" },
        { label: "ไม่ผ่านเกณฑ์พิจารณา", value: "Rejected" },
      ],
      requestList: [
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    if (this.isOIC) this.searchData.status = "Submitted";

    this.getAllForms();
  },
  computed: {
    ...mapState({
      isRSP: (state) => state.Auth.User.user_type === "RSP",
      isUSP: (state) => state.Auth.User.user_type === "USP",
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
  },
  methods: {
    async getAllForms(page) {
      let payload = {
        page: page,
        // per_page: 1,
        status:
          this.searchData.status ??
          "Rejected,In Review,Submitted,Approved,Draft",
        keyword: this.searchData.keyword,
      };
      console.info(payload);

      let res = await this.$apiFire("Request/getSpaceRequestsList", payload);
      console.info(res);
      if (res) {
        this.requestList = res.data.map((item, index) => {
          return {
            ...item,
            count: (res.current_page - 1) * res.per_page + index + 1,
          };
        });
        this.paginate = {
          total: res.total,
          per_page: res.per_page,
          current_page: res.current_page,
          last_page: res.last_page,
        };
      }
    },
    createForm() {
      this.$router.push({ name: "spaceRequestsForm" });
    },
    goToRequestPreview(id) {
      this.$router.push({
        path: `/space-requests-management/space-requests-preview/${id}?preview=true`,
      });
    },
    onEdit(id) {
      this.$router.push({
        path: `/space-requests-management/space-requests-form/${id}`,
      });
    },
    onDelete(id) {
      console.info(id);
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("Request/deleteSpaceRequestsForm", id);
          if (res) {
            this.requestList = this.requestList.filter((item) => item.id != id);
            this.$store.commit("General/setModal", {
              title: "เสร็จสิ้น!",
              theme: "success",
              text: res,
              showCancel: false,
            });
          }
        },
      });
    },
    dateFormatting(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);

      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };
      const thaiLocaleDate = new Intl.DateTimeFormat("th-TH", options).format(
        date
      );

      const thaiMonthAbbreviations = {
        มกราคม: "ม.ค.",
        กุมภาพันธ์: "ก.พ.",
        มีนาคม: "มี.ค.",
        เมษายน: "เม.ย.",
        พฤษภาคม: "พ.ค.",
        มิถุนายน: "มิ.ย.",
        กรกฎาคม: "ก.ค.",
        สิงหาคม: "ส.ค.",
        กันยายน: "ก.ย.",
        ตุลาคม: "ต.ค.",
        พฤศจิกายน: "พ.ย.",
        ธันวาคม: "ธ.ค.",
      };
      const [day, month, yearTime] = thaiLocaleDate.split(" ");

      const abbreviatedMonth = thaiMonthAbbreviations[month] || month;

      const year = parseInt(yearTime, 10);

      const time = thaiLocaleDate.split(" ")[4];
      const hour = time.split(":")[0];
      const minute = time.split(":")[1];

      return `${day} ${abbreviatedMonth} ${year} เวลา ${hour}:${minute} น.`;
    },
    changeColor(status) {
      switch (status) {
        case "Draft":
          return "2";
        case "In Review":
          return "1";
        case "Submitted":
          return "10";
        case "Approved":
          return "3";
        case "Rejected":
          return "4";
      }
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Draft":
          return "var(--theme-color-seven)";

        case "In Review":
          return "var(--theme-color-five)";

        case "Rejected":
          return "var(--theme-color-four)";

        case "Submitted":
          return "var(--theme-color-ten)";

        case "Approved":
          return "var(--theme-color-three)";
        default:
          return "var(--theme-color-two)";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.txt__black {
  color: var(--theme-color-two);
}
.txt__green {
  color: var(--theme-color-three);
}
</style>
